<template>
    <div class="policy-version-stack">
        <ChildPrivacyPolicy20260720Content />
        <PersonalInfoPolicy20260720Content />
    </div>
</template>

<script>
import ChildPrivacyPolicy20260720Content from '@/views/policy/common/ChildPrivacyPolicy20260720Content.vue';
import PersonalInfoPolicy20260720Content from '@/views/policy/common/PersonalInfoPolicy20260720Content.vue';

export default {
    name: 'ChildPolicy20260720',
    components: {
        ChildPrivacyPolicy20260720Content,
        PersonalInfoPolicy20260720Content,
    },
};
</script>
